import TokenLogo from '~/components/TokenLogo'
import {
  StyledTokenAmount,
  StyledTokenLabel,
  StyledTokenRow,
  StyledTokenValue,
} from './styled'

export interface ITokenRow {
  token: BaseTokenlonToken
  amount: number | string
  usdValue?: number | string
}
export const TokenRow: React.FC<ITokenRow> = ({ token, amount, usdValue }) => {
  return (
    <StyledTokenRow>
      <TokenLogo large logo={token?.logo} symbol={token?.symbol} space={0} />
      <StyledTokenLabel>
        {typeof usdValue !== 'undefined' && (
          <StyledTokenValue>~ {usdValue}</StyledTokenValue>
        )}
        <StyledTokenAmount>
          {amount} {token?.symbol}
        </StyledTokenAmount>
      </StyledTokenLabel>
    </StyledTokenRow>
  )
}
